import React from 'react';
import PropTypes from 'prop-types';
import { get, defaultTo } from 'lodash';
import { AccountCard } from 'web-ui-components/lib/molecules/cards';
import { getAccountDisplayNumber } from '../../businessLogic/AccountsBL';

const AccountTypeCard = ({ accountDetails }) => {
  const displayName = defaultTo(
    get(accountDetails, 'metadata.display_name'),
    get(accountDetails, 'product.name')
  );
  const { sortcode, accNumber } = getAccountDisplayNumber(accountDetails);
  return (
    <div className="u-margin-top-1 u-margin-bottom-1">
      <AccountCard title={displayName} sortCode={sortcode} accountNumber={accNumber} />
    </div>
  );
};
AccountTypeCard.propTypes = {
  accountDetails: PropTypes.shape({}),
};

export default AccountTypeCard;
